import { render, staticRenderFns } from "./AdminTag.vue?vue&type=template&id=12c174d7&scoped=true"
import script from "./AdminTag.vue?vue&type=script&lang=js"
export * from "./AdminTag.vue?vue&type=script&lang=js"
import style0 from "./AdminTag.vue?vue&type=style&index=0&id=12c174d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c174d7",
  null
  
)

export default component.exports